var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { useGridContext, useGridToggleableContext } from '../features';
import { getFlexStyleForColumn } from '../utils';
import { GridToggleMenu } from './GridToggleMenu';
var HeaderBox = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    overflow: hidden;\n    border-bottom: 2px solid ", ";\n    height: ", ";\n    box-sizing: border-box;\n\n    position: relative;\n    display: flex;\n    align-items: center;\n\n    ", "\n"], ["\n    overflow: hidden;\n    border-bottom: 2px solid ", ";\n    height: ", ";\n    box-sizing: border-box;\n\n    position: relative;\n    display: flex;\n    align-items: center;\n\n    ",
    "\n"])), function (props) { return props.theme.colorBorderMain; }, function (props) { return props.headerHeight + "px"; }, function (props) {
    return props.isEmpty && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            width: ", "px;\n        "], ["\n            width: ", "px;\n        "])), props.rowWidth);
});
var Header = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    flex: 0 0 ", ";\n    height: 100%;\n"], ["\n    display: flex;\n    align-items: center;\n    flex: 0 0 ", ";\n    height: 100%;\n"])), function (props) { return props.rowWidth + "px"; });
export var gridHeaderCellId = 'grid-header-cell-in-row';
var GridHeaderCells = function () {
    var columnsWidth = useGridContext().state.columnsWidth;
    var visibleColumns = useGridToggleableContext().visibleColumns;
    return (React.createElement(React.Fragment, null, visibleColumns.map(function (column) {
        var columnWidth = columnsWidth[column.key];
        var columnMinWidth = column.props.minWidth;
        var computedStyle = getFlexStyleForColumn(column, {
            isHeaderCell: true,
            width: columnWidth
        });
        return (React.createElement("div", { "data-selector-id": gridHeaderCellId, key: "Header-" + column.key, style: computedStyle }, !!column.props.headerCell &&
            React.createElement(column.props.headerCell, {
                cellData: column.props.title,
                headerJustify: column.props.headerJustify,
                totalColumn: column.props.totalColumn,
                columnKey: column.key,
                columnMinWidth: columnMinWidth,
                columnWidth: columnWidth,
                contentRenderer: column.props.headerCellContent,
                columnField: column.props.field,
                columnId: column.props.columnId,
                onHeaderClick: column.props.onHeaderClick
            })));
    })));
};
export var gridHeaderBoxId = 'grid-header-box';
var GridHeader = forwardRef(function (props, ref) {
    var _a = useGridContext().state, headerHeight = _a.headerHeight, hideHeader = _a.hideHeader, isEmpty = _a.isEmpty, toggleable = _a.toggleable;
    var rowWidth = useGridToggleableContext().rowWidth;
    if (hideHeader) {
        return null;
    }
    return (React.createElement(HeaderBox, { "data-selector-id": gridHeaderBoxId, headerHeight: headerHeight, rowWidth: rowWidth, isEmpty: isEmpty },
        React.createElement(Header, { rowWidth: rowWidth, ref: ref },
            React.createElement(GridHeaderCells, null)),
        toggleable && React.createElement(GridToggleMenu, null)));
});
export default GridHeader;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=GridHeader.js.map